module.exports = __webpack_public_path__ + "0763bf37a4db3100ba5f7329298e7644.png";